import alert from '@/images/Alert.svg';
import logoutIcon from '@/images/LogoutV2.svg';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { MaskedIcon } from '../MaskedIcon/MaskedIcon';
import CtaBanner from './CtaBanner';

const AccountNotPrimaryBanner = () => {
    const { logout } = useAuth();
    const mixpanel = useAnalytics();

    const handleCta = async () => {
        mixpanel?.track('not-your-primary-account', { event: 'click' });
        logout({ returnTo: window.location.origin });
    };

    return (
        <CtaBanner
            icon={<MaskedIcon src={alert} size="24px" />}
            subtitle="You have another account using this email. Please log out and back in using another method"
            ctaText="Logout"
            ctaIcon={<MaskedIcon src={logoutIcon} size="20px" />}
            onCta={handleCta}
        />
    );
};

export default AccountNotPrimaryBanner;
